/**
 * Detects the user's browser based on user agent
 * @returns {string} The name of the detected browser
 */
function getBrowserName() {
	const { userAgent } = navigator
	if (/SamsungBrowser/i.test(userAgent)) return 'Samsung Internet'
	if (/UCBrowser/i.test(userAgent)) return 'UC Browser'
	if (/edg/i.test(userAgent)) return 'Edge'
	if (/firefox/i.test(userAgent)) return 'Firefox'
	if (/opr\/|opera/i.test(userAgent)) return 'Opera'
	if (/brave/i.test(userAgent)) return 'Brave'
	if (/DuckDuckGo/.test(userAgent) && /DuckDuckGo/.test(navigator.vendor)) return 'DuckDuckGo'
	if (/vivaldi/i.test(userAgent)) return 'Vivaldi'
	if (/yabrowser/i.test(userAgent)) return 'Yandex Browser'
	if (/chrome|chromium|crios/i.test(userAgent)) return 'Chrome'
	if (/safari/i.test(userAgent) && !/chrome|chromium|crios/i.test(userAgent)) return 'Safari'
	if (/msie|trident/i.test(userAgent)) return 'Internet Explorer'
	return userAgent.substring(0, 10)
}

/**
 * Checks if the browser is supported (Chromium-based or Safari)
 * @returns {boolean} True if browser is supported
 */
export function isSupportedBrowser() {
	const name = getBrowserName()
	const supported = ['Chrome', 'Edge', 'Opera', 'Brave', 'Vivaldi', 'Samsung Internet', 'Yandex Browser', 'Safari']
	return supported.includes(name)
}

export default getBrowserName
